import { AfterViewInit, Component, OnInit } from '@angular/core';
import { FirebaseService } from "../../providers/firebase.service";
import { ActivatedRoute, Router } from "@angular/router";
import { Client } from "../../models/client";
import { ScrollService } from "../../providers/scroll.service";
import { PageSettings } from '../../models/pageSettings';
import { isUndefined } from 'util';

@Component({
  selector: 'app-blog-settings',
  templateUrl: './blog-settings.component.html',
  styleUrls: ['./blog-settings.component.css']
})
export class BlogSettingsComponent implements OnInit, AfterViewInit {
  key: string;
  clientData: Client;
  pageSettings: PageSettings;

  constructor(
    private afService: FirebaseService,
    private router: Router,
    private route: ActivatedRoute,
    private scroll: ScrollService
  ) { }

  ngOnInit() {
    this.route.params.subscribe((params) => {
      this.key = params['key'];
      this.afService.getClientInfo(this.key).subscribe(clientData => {
        this.clientData = clientData;
        // this.afService.getCustomPages(this.key).subscribe(pages => {
        //   this.pages = pages;
        // });
      });
    });

    this.afService.loadPageSettings(this.key).subscribe((data) => {
      if (isUndefined(data.$value)) {
        this.pageSettings = data;
        if (isUndefined(this.pageSettings.blogListingPageMetaData)) {
          this.pageSettings.blogListingPageMetaData = {
            metaTitle: "",
            metaDescription: ""
          };
          this.savePageSettings();
        }
      }
    });
  }

  ngAfterViewInit() {
    this.scroll.scrollToTop();
  }

  goBack() {
    this.router.navigate(['../../'], { relativeTo: this.route });
  }

  updateEnableBlogToggle(e) {
    this.clientData.enableBlog = e.checked;
    this.afService.updateClient(this.clientData).then(() => {
      this.afService.openSnackBar('Client successfully updated.');
    }).catch(e => {
      this.afService.openSnackBar(e.message);
    });
  }

  savePageSettings() {
    this.afService.savePageSettings(this.clientData, this.pageSettings).then(() => {
      this.afService.openSnackBar('Page Settings Updated Successfully');
    }).catch(e => {
      this.afService.openSnackBar(e.message);
    });
  }
}



// WEBPACK FOOTER //
// ./src/ng2/app/admin-portal/blog-settings/blog-settings.component.ts